// eslint-disable-next-line import/no-cycle
import bffApi, {BffResponse} from '@client/bffApi';
import {
  AccountRequest,
  Beneficiary,
  CustodianService,
  SaveTrustedContactOptions,
  TrustedContact,
} from '@simpleinvest/ms-custodian-sdk';
import {apiKey, getLogger} from '@client/services/sdk';
// eslint-disable-next-line import/no-cycle
import {
  requestInterceptorFulfilledHandler,
  requestInterceptorRejectedHandler,
  responseInterceptorFulfilledHandler,
  responseInterceptorRejectedHandler,
} from '@client/interceptors';
import {AxiosResponse} from 'axios';
import {SourcePlatform} from '@simpleinvest/ms-core-sdk';
import {BeneficiaryChangesRequest, NewAccountBeneficiaryRequest} from './request/ServiceRequest';

export default {
  getCustodianServiceInstance(): CustodianService {
    return new CustodianService({
      apiKey,
      sourceInfo: {platform: SourcePlatform.ClientPlatform},
      interceptors: {
        requestInterceptor: requestInterceptorFulfilledHandler,
        requestRejectedInterceptor: requestInterceptorRejectedHandler,
        responseInterceptor: responseInterceptorFulfilledHandler,
        responseRejectedInterceptor: responseInterceptorRejectedHandler,
      },
      logger: getLogger(),
    });
  },

  async getBeneficiariesForClUserId(clUserId: string): Promise<unknown> {
    const service: CustodianService = await this.getCustodianServiceInstance();

    return service.getBeneficiariesForClUserId({clUserId});
  },

  // PUT: /clients/{clUserId}/beneficiaries/save-changes
  async saveBeneficiaryChanges(payload: BeneficiaryChangesRequest): Promise<AxiosResponse<BffResponse<Beneficiary[]>>> {
    const result = await bffApi
      .getAxiosInstance()
      .put<BffResponse<Beneficiary[]>>(
        `${bffApi.getBaseUrl(true)}/clients/${payload.clUserId}/beneficiaries/save-changes`,
        payload
      );

    return result;
  },

  // DELETE: /v1/beneficiaries/
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async deleteBeneficiaries(accountRequestId: number): Promise<any> {
    const service: CustodianService = await this.getCustodianServiceInstance();

    return service.deleteBeneficiaries({accountRequestId});
  },

  // POST: /clients/{clUserId}/beneficiaries/save-for-new-account
  async saveBeneficiariesForNewAccount(
    payload: NewAccountBeneficiaryRequest
  ): Promise<AxiosResponse<BffResponse<AccountRequest>>> {
    const result = await bffApi
      .getAxiosInstance()
      .post<BffResponse<AccountRequest>>(
        `${bffApi.getBaseUrl(true)}/clients/${payload.clUserId}/beneficiaries/save-for-new-account`,
        payload
      );

    return result;
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async getSelectedAccountDetails(accountRequestId: number): Promise<any> {
    const service: CustodianService = await this.getCustodianServiceInstance();

    return service.getAccountRequest({accountRequestId});
  },

  async saveTrustedContactChanges(payload: SaveTrustedContactOptions): Promise<TrustedContact> {
    const service: CustodianService = await this.getCustodianServiceInstance();

    return service.saveTrustedContactsChanges(payload);
  },
};
